module.exports = __webpack_public_path__ + "Flag-620.a9b7e8f4574ede77c59de9c379dd6463.svg";